export default {
  takeAwayHasMenu: (state) => state.hasTakeAwayMenu,
  takeAwayOrders: (state) => state.orders,
  takeAwayPreOrders: (state) => state.preOrders
}
